import { render, staticRenderFns } from "./FileViewerVideo.vue?vue&type=template&id=06075989&scoped=true&"
import script from "./FileViewerVideo.vue?vue&type=script&lang=ts&"
export * from "./FileViewerVideo.vue?vue&type=script&lang=ts&"
import style0 from "./FileViewerVideo.vue?vue&type=style&index=0&id=06075989&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06075989",
  null
  
)

export default component.exports